import type { WorkspaceElsewhereRow } from "@elaso/shared/types/db";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function CrossInstanceConsentDialog({
	entry,
	onAccept,
	onDecline,
}: {
	entry: WorkspaceElsewhereRow | null;
	onAccept: (entry: WorkspaceElsewhereRow) => void;
	onDecline: () => void;
}) {
	const host = entry ? new URL(entry.hostInstanceUrl).host : "";
	return (
		<AlertDialog
			onOpenChange={(open) => {
				if (!open) onDecline();
			}}
			open={entry !== null}
		>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>Open {entry?.workspaceName}?</AlertDialogTitle>
					<AlertDialogDescription>
						{entry?.hostOrganizationName} hosts this workspace on another ELASO
						Instance, {host}. Opening it makes an account for you there. Your
						name, your email, your photo and your role in this course go with
						you. Your password does not. You are asked once.
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>Not now</AlertDialogCancel>
					<AlertDialogAction
						onClick={() => {
							if (entry) onAccept(entry);
						}}
					>
						Continue
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
